module.exports = __webpack_public_path__ + "media/images/forms/checkmark-outline-160c67f32e01a1d1f9e475d3ecf2a64e.svg";